module.exports = __webpack_public_path__ + "static/Pedro-71bf7fd78aeb67a3b4cbcdb708f25ae6.jpg";